import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import { useFieldArray, useForm } from "react-hook-form";
import LabStepHeader from "./LabStepHeader";
import { Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyDate from "../../../MyComp/UI/form/MyDate";
import moment from "moment";
import MyGST from "../../../MyComp/UI/form/MyGST";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { createLabComplianceAPI, getLabDetailsOneAPI, getLabDetailsTwo } from "../../../api/lab";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../../assets/constants";

const LabCompliance2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      qualificationDD: [],
      specializationDD: [],

      objectionKeys: [],
      approvedKeys: [],
      cmo: null,
      cmo_image: null,

      pan_image: null,
      pan: null,

      nabl_certificate: null,
      nabl_certificate_img: null,

      nabh_certificate: null,
      nabh_certificate_img: null,

      other_certificate: null,
      other_certificate_img: null,

      lab_license: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "lab_license",
  });
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const queryParams = new URLSearchParams(location.search);
  const labId = queryParams.get("labId");
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("labId", labId);

    const pan = watch("pan");
    if (pan instanceof File) {
      formData.append("pan", pan);
    } else if (typeof pan === "string") {
      formData.append("pan", pan);
    }

  
    // formData.append("nablEndDate", moment(watch("nablEndDate")).format("YYYY-MM-DD") || null);
 if(isNablCertified){
    formData.append("nablId", watch("nablId"));
     const nabl_certificate = watch("nabl_certificate");
    if (nabl_certificate instanceof File) {
      formData.append("nabl_certificate", nabl_certificate);
    } else if (typeof nabl_certificate === "string") {
      formData.append("nabl_certificate", nabl_certificate);
    }
 }
formData.append("nabl_certified", data.isNablCertified || false);

    // formData.append("nabhId", watch("nabhId"));
    // formData.append("nabhEndDate", moment(watch("nabhEndDate")).format("YYYY-MM-DD") || null);
    // const nabh_certificate = watch("nabh_certificate");
    // if (nabh_certificate instanceof File) {
    //   formData.append("nabh_certificate", nabh_certificate);
    // } else if (typeof nabh_certificate === "string") {
    //   formData.append("nabh_certificate", nabh_certificate);
    // }

    formData.append("otherIds", watch("otherIds"));
    // formData.append("otherEndDate", moment(watch("otherEndDate")).format("YYYY-MM-DD") || null);
    const other_certificate_img = watch("other_certificate_img");
    if (other_certificate_img instanceof File) {
      formData.append("other_certificate_img", other_certificate_img);
    } else if (typeof other_certificate_img === "string") {
      formData.append("other_certificate_img", other_certificate_img);
    }

    data?.lab_license?.forEach((item, index) => {
      formData.append(`lab_license[${index}].certificate`, item.certificate || "");
    });

    formData.append("licenseNumber", watch("licenseNumber"));
    formData.append("gstNumber", watch("gstNumber"));
    const cmoFile = watch("cmo");
if (cmoFile instanceof File) {
  formData.append("cmo_certificate", cmoFile);
}

    formData.append("cmoCertificateNumber", watch("cmoNumber"));
    console.log("body", data);

    if (mode === "Add" || mode === "Edit") {
      createLabComplianceAPI(formData).then((res) => {
        if (res.data.status === true) {
          navigate(`/laboratory-and-diagnostics/service-and-catalog?labId=${labId}`, {
            state: { mode: mode, labId: mode === "Add" ? res.data.data?.labId : location.state.labId },
          });
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };
  console.log("lab", labId);
  const isNablCertified = watch("isNablCertified");
  useEffect(() => {
  if (mode === "Edit") {
    getTwoDetails();
  }
}, [mode]);

const getTwoDetails = () => {
  getLabDetailsTwo({ labId: location.state.labId })
    .then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;

setValue("isNablCertified", data.nabl_certified );

        setValue("name", data.name);
        setValue("lab_type", data.lab_type);
        setValue("pincode", data.pincode);
        setValue("state", data.state);
        setValue("city", data.city);
        setValue("address", data.address);
        setValue("map_link", data.map_link);
        setValue("person_name", data.person_name);
        setValue("contact_number", data.contact_number);
        setValue("mobile", data.mobile);
        setValue("alt_contact_number", data.alt_contact_number);

        
        // setValue("isNablCertified", !!data.nablId);
        setValue("nablId", data.nablId);
        setValue("nabl_certificate_img", `${BASE_URL_IMG}${data.nabl_certificate}`);
        // setValue("nablEndDate", data.nablEndDate ? new Date(data.nablEndDate) : null);

      
        setValue("otherIds", data.otherIds);
  
             setValue("other_certificate",`${BASE_URL_IMG}${ data.other_certificate_img}`);
             
             setValue("other_certificate_img",`${BASE_URL_IMG}${ data.other_certificate_img}`);
        // setValue("otherEndDate", data.otherEndDate ? new Date(data.otherEndDate) : null);

      
        setValue("gstNumber", data.gstNumber);
        setValue("licenseNumber", data.licenseNumber);
        setValue("pan_image", `${BASE_URL_IMG}${data.pan}`);
        setValue("cmo_image",`${BASE_URL_IMG}${data.cmo_certificate}`);
         setValue("cmo",`${BASE_URL_IMG}${data.cmo_certificate}`);
        setValue("cmoNumber", data.cmoCertificateNumber);

        if (data.license_documents?.length) {
          data.license_documents.forEach(doc => {
            append({
              certificate: doc.url,
              certificate_url: doc.url
            });
          });
        }
      reset({
          ...getValues(),
          lab_license: [], 
        });

        if (data.license_documents?.length) {
          data.license_documents.forEach((doc) => {
            append({
              certificate: `${BASE_URL_IMG}${ doc.url}`,      
              certificate_url: `${BASE_URL_IMG}${ doc.url}`,
            });
          });
        } else {
        
          append({ certificate: null, certificate_url: null });
        }
        trigger();
      } else if (res.data.status === "expired") {
        logout();
      }
    })
    .catch(() => {
      setValue("tableLoading", false);
    });
};

  return (
    <>
      <Head title={"Accreditation & Compliance"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Laboratory Registration"}
              </BlockTitle>
            </BlockHeadContent>
              <BlockHeadContent>
                          <div className="">
                            <Button
                              color="primary"
                              outline
                              className={`  me-n1`}
                              onClick={() => {
                                navigate(-1);
                              }}
                            >
                              <Icon name={"arrow-left"} />
                            </Button>
                          </div>
                        </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <LabStepHeader current={2} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col xs="12" sm="6" md="4" lg="3">
                  <div className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isNablCertified"
                      {...register("isNablCertified")}
                    />
                    <label className="form-check-label" htmlFor="isNablCertified">
                      NABL Certified
                    </label>
                  </div>
                </Col>

                {isNablCertified && (
                  <Col xs="12" sm="6" md="4" lg="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="NABL ID"
                      name="nablId"
                      placeholder="Enter NABL ID"
                      // required
                    />
                  </Col>
                )}
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors} 
                    title={"Validity Period"}
                    name={"nablEndDate"}
                    placeholder={"choose validity period"}
                    // required
                    min={moment().add(2, "months").toDate()} // today
                    max={moment().add(10, "years").toDate()} // 10 years from now
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                {isNablCertified && (
                  <Col xs="12" sm="6" md="4" lg="3" className={``}>
                    <ImageUpload
                      getValues={getValues}
                      approve={mode === "Approval" ? true : false}
                      design={4}
                      id="nabl_certificate"
                      watch={watch}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"NABL Accreditation Certificate"}
                      errors={errors}
                      register={register}
                      image={"nabl_certificate"}
                      image_url={"nabl_certificate_img"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      // required
                      validateDoc
                      disabled={mode == "Approval"}
                    />
                  </Col>
                )}
                {/* <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="NABH ID"
                    name="nabhId"
                    placeholder="Enter NABH ID"
                    // required
                  />
                </Col> */}
                {/* 
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Validity Period"}
                    name={"nabhEndDate"}
                    placeholder={"choose validity period"}
                    // required
                    min={moment().add(2, "months").toDate()} // today
                    max={moment().add(10, "years").toDate()} // 10 years from now
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="nabh_certificate"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"NABH Accreditation Certificate"}
                    errors={errors}
                    register={register}
                    image={"nabh_certificate"}
                    image_url={"nabh_certificate_img"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Other ID"
                    name="otherIds"
                    placeholder="Enter Other ID"
                    // required
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Validity Period"}
                    name={"otherEndDate"}
                    placeholder={"choose validity period"}
                    // required
                    min={moment().add(2, "months").toDate()} // today
                    max={moment().add(10, "years").toDate()} // 10 years from now
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="other_certificate"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Other Certificate"}
                    errors={errors}
                    register={register}
                    image={"other_certificate_img"}
                    image_url={"other_certificate"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyGST
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="GST Number"
                    name="gstNumber"
                    placeholder="Enter gst number"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="License Number"
                    name="licenseNumber"
                    placeholder="Enter license number"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="pan_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    // required
                    validateDoc
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval"}
                    design={4}
                    id="cmo_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label="CMO Certificate"
                    errors={errors}
                    register={register}
                    image="cmo"
                    image_url="cmo_image"
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode === "Approval"}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="CMO Number"
                    name="cmoNumber"
                    placeholder="Enter Lab. Reg. number"
                    required
                  />
                </Col>
                {fields.map((field, index) => (
                  <>
                    <Col md="2" key={field.id}>
                      {" "}
                      <ImageUpload
                        getValues={getValues}
                        id={`certificate_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Lab License`}
                        image={`lab_license.${index}.certificate`}
                        image_url={`lab_license.${index}.certificate_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        // required
                        validateDoc
                        rm
                        index={index}
                        remove={remove}
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))}
                {/* {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ certificate: null, certificate_url: null });
                      }}
                    >
                      {"Add License"}
                    </Button>{" "}
                  </Col>
                )} */}
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default LabCompliance2;
